export const formatToBRNumber = (value) => {
    if (value === null || value === undefined) {
        return '-';
    }

    return new Intl.NumberFormat('pt-BR').format(value);
};

const formatToPercentage = (number) => {
    return `${Number(number).toFixed(2)}%`;
};

export const number = {
    formatToBRNumber,
    formatToPercentage
};
